/*******************************************************************************
 * Copyright (c) 2024 Belltane LLC
 *
 * All rights reserved.
 *
 * Contributors:
 *   Amina Rais - Initial implementation
 *
 * Version: 1.0.0
 *
 *******************************************************************************/

import React from 'react';
import Grid from '@mui/material/Grid';
import { makeStyles } from 'tss-react/mui';
import { Typography } from '@mui/material';
import { BrowserView } from 'react-device-detect';
import { useTranslation } from 'react-i18next';


const Aboutustext = () => {

    const { classes } = useStyles();
    const { t } = useTranslation()
    return (
        <>
            <main>
                <BrowserView>

                    <Grid container className={classes.container}>
                        <Grid item xs={12} sm={12} md={12} style={{ margin: '30px' }}>
                            <Typography variant="h2" align="center">
                                {t('titles:aboutus')}

                            </Typography>
                            <div className={classes.sectionTitleBorder}></div>
                            <div className={classes.aboutuspara}>
                                <Typography variant="h3" align="center" style={{ margin: '10px', color: "white", lineHeight: '1.75' }} paragraph>
                                    🤖 Welcome to our AI-powered social media hub! Here, technology and human connections merge to create an enriched social experience. We're more than a platform; we're a cutting-edge community powered by intelligent insights and personalized interactions.
                                </Typography>
                                <Typography variant="h3" align="center" style={{ margin: '10px', color: "white", lineHeight: '1.75' }} paragraph>
                                    🌟 Our mission is to harness the power of artificial intelligence to cultivate a space where users can connect, share, and discover with unprecedented ease. Whether you're looking to express your creativity, seek tailored content, or simply enjoy a seamless social experience, our AI-enhanced platform is here to support your digital journey.
                                </Typography>
                                <Typography variant="h3" align="center" style={{ margin: '10px', color: "white", lineHeight: '1.75' }} paragraph>
                                    🌐 We celebrate the synergy of advanced technology and human interaction. Our AI algorithms work tirelessly to bring you relevant content, foster meaningful connections, and elevate your online experience, making our community vibrant and dynamic.
                                </Typography>
                                <Typography variant="h3" align="center" style={{ margin: '10px', color: "white", lineHeight: '1.75' }} paragraph>
                                    🤝 Join us in exploring the future of social media, where AI-driven recommendations, intelligent content curation, and smart engagement tools transform the way we connect. Let's create a space that is not only innovative but also empathetic and inclusive, reflecting the diversity of our global community.
                                </Typography>
                                <Typography variant="h3" align="center" style={{ margin: '10px', color: "white", lineHeight: '1.75' }} paragraph>
                                    Ready to experience the next generation of social media? Join us and be part of an intelligent, dynamic journey powered by AI! 🌍✨
                                </Typography>
                            </div>

                        </Grid>
                    </Grid>
                </BrowserView>

            </main>
        </>
    );
}


const useStyles = makeStyles({ "name": { Aboutustext } })((theme) => ({





    container: {
        maxHeigh: '500px!important',
        display: 'contents!important',
        margin: '50px!important',
        zIndex: '1',
        position: 'relative',
        minHeight: '300px!important',
        height: '500px!important',
        padding: '50px!important',
        backgroundColor: theme.palette.background.paper,

        color: "white"

    },

    sectionTitleBorder: {
        width: '100px',
        height: '2px',
        marginRight: 'auto',
        marginLeft: 'auto',
        backgroundColor: '#fb743e',
        marginBottom: '30px',
        color: "white"

    }, aboutuspara: {
        marginRight: 'auto',
        marginLeft: 'auto',
        marginBottom: '30px',
        maxWidth: '800px',
        backgroundColor: theme.palette.background.paper,
        color: "white"
    }
}));

export default Aboutustext;